import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogo, Bank, LockKey, UserList, Folder } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/calculator", { replace: true });
  }, [loading, user, navigate]);

  return (
    <main
      data-testid="login-page"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 flex justify-center"
    >
      <div className="w-full max-w-md">
        <div className="bg-white border border-brand-line rounded-md p-8 md:p-10">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-md bg-brand-forest text-brand-bone">
            <Bank weight="duotone" size={24} />
          </span>
          <span className="label-eyebrow block mt-6">Advisor access</span>
          <h1 className="mt-3 font-serif text-3xl md:text-4xl text-brand-forest leading-tight">
            Sign in to your workspace
          </h1>
          <p className="mt-3 text-sm text-brand-ink/70">
            Your scenarios, leads, and billing live in a private workspace tied to your
            Google account. No other advisor can see your data.
          </p>

          <button
            onClick={login}
            data-testid="btn-google-signin"
            className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-md bg-brand-forest hover:bg-brand-forestHover text-brand-bone h-12 px-6 text-sm font-semibold transition-colors"
          >
            <GoogleLogo size={20} weight="bold" /> Continue with Google
          </button>

          <div className="mt-8 pt-6 border-t border-brand-line space-y-3">
            <Perk icon={LockKey} text="Private, isolated workspace per advisor" />
            <Perk icon={UserList} text="Your leads and funnel data — yours only" />
            <Perk icon={Folder} text="Saved scenarios and branded PDF exports" />
          </div>
        </div>
      </div>
    </main>
  );
}

function Perk({ icon: Icon, text }) {
  return (
    <div className="flex items-center gap-2.5 text-xs text-brand-ink/70">
      <Icon size={15} weight="duotone" className="text-brand-copper shrink-0" />
      {text}
    </div>
  );
}
